import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const Collapsable = props => {
  const {
    children,
    height,
    btnText = 'Read More',
    btnTextShowLess = 'Collapse',
    btnHidden,
    maskHidden,
    isCollapsed,
  } = props;

  const [collapsed, setCollapsed] = useState();

  useEffect(() => {
    setCollapsed(!collapsed);
  }, [isCollapsed]);

  const onButtonClick = () => {
    setCollapsed(!collapsed);
  };

  return (
    <div className="collapsable">
      <div
        className={
          collapsed && !maskHidden
            ? 'collapsable__content collapsable__content--collapsed'
            : 'collapsable__content'
        }
        style={{ maxHeight: collapsed ? height : '100%' }}
      >
        {children}
      </div>

      {btnHidden ? null : (
        <button className="collapsable__button" onClick={onButtonClick}>
          {collapsed ? btnText : btnTextShowLess}
        </button>
      )}
    </div>
  );
};

Collapsable.defaultProps = {
  height: 110,
  btnText: 'Read More',
  btnHidden: false,
  maskHidden: false,
};

Collapsable.propTypes = {
  height: PropTypes.number,
  btnText: PropTypes.string,
  btnHidden: PropTypes.bool,
  maskHidden: PropTypes.bool,
  children: PropTypes.object,
  isCollapsed: PropTypes.bool,
};

export default Collapsable;
